import React, { FC } from 'react';
import { AddLiquiditySectionTitle } from '@app/screens/liquidity/AddLiquidityV3/components/AddLiquiditySectionTitle';
import EnterAmounts from '@app/screens/liquidity/AddLiquidityV3/components/EnterAmounts';
import { VStack } from '@chakra-ui/react';
import { Currency, Price, Token } from '@cryptoalgebra/kim-sdk';
import { IDerivedMintInfo } from '@app/state/mintStore';

interface Props {
  price: Price<Token, Token> | undefined;
  mintInfo: IDerivedMintInfo;
  currencyA: Currency | undefined;
  currencyB: Currency | undefined;
}

const AddLiquidityInputAmounts: FC<Props> = ({
  currencyA,
  price,
  currencyB,
  mintInfo
}) => {
  const areCurrenciesSelected = !!(currencyB && currencyA);
  const areAmountsValid = !!(
    mintInfo.parsedAmounts.CURRENCY_A && mintInfo.parsedAmounts.CURRENCY_B
  );

  return (
    <VStack w="100%" gap={4}>
      <AddLiquiditySectionTitle
        label="Input amounts"
        isCompleted={!!price && areAmountsValid}
      />
      {areCurrenciesSelected && (
        <EnterAmounts
          currencyA={currencyA}
          currencyB={currencyB}
          mintInfo={mintInfo}
        />
      )}
    </VStack>
  );
};

export default AddLiquidityInputAmounts;
